// This code was copied from the file app/pages/upgrade/components/PlanCards/TierCard.tsx
// This was done in an attempt to minimize changes to the existing structure and add the new changes elsewhere
// until we're able to integrate this into the DreamBuilder project.

import { useTranslation } from 'react-i18next';

import Typography from '~/components/Typography';
import type { FontSizes } from '~/interfaces/font_family';
import type { Price, PriceInterval } from '~/interfaces/subscriptions';

import currencyFormatter from '../../../utils/currencyFormatter';

interface Props {
  fontFamily: string;
  priceFontSize: FontSizes;
  accentColor: string;
  price: Price;
  txtColor: string;
  isExternalCheckoutEnabled: boolean;
}

const GiftCardPriceBlock = ({
  fontFamily,
  priceFontSize,
  accentColor,
  price,
  txtColor,
  isExternalCheckoutEnabled,
}: Props) => {
  const { t } = useTranslation();
  const isDiscounted = price.amount_cents !== price.original_amount_cents;
  const priceIntervalDisplays: Record<PriceInterval, string> = {
    month: 'upgrade.tabs.gift.interval.one_month',
    year: 'upgrade.tabs.gift.interval.one_year',
    one_time: 'upgrade.tabs.gift.interval.lifetime',
    donation: '',
  };

  return (
    <div className="block">
      <div className="space-y-1">
        {!isExternalCheckoutEnabled && (
          <Typography
            size="sm"
            weight="bold"
            fontFamily={fontFamily}
            color={accentColor}
            className="truncate capitalize"
          >
            {price.cta}
          </Typography>
        )}

        <div className="flex w-full flex-wrap">
          {isDiscounted && (
            <Typography
              as="h4"
              size={priceFontSize}
              weight="semibold"
              fontFamily={fontFamily}
              color={txtColor}
              className="mr-1 line-through opacity-25"
            >
              {currencyFormatter({ currency: price.currency }).format((price.original_amount_cents || 0) / 100)}
            </Typography>
          )}
          <Typography as="h4" size={priceFontSize} weight="semibold" fontFamily={fontFamily} color={txtColor}>
            <div className="flex flex-row items-center">
              {currencyFormatter({ currency: price.currency }).format((price.amount_cents || 0) / 100)}
            </div>
          </Typography>
          <Typography as="span" size="xl" weight="semibold" fontFamily={fontFamily} color={txtColor} className="ml-1">
            {t(priceIntervalDisplays[price.interval])}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default GiftCardPriceBlock;
